import { Form } from "antd"
import React from "react"

export default function FormItem({ children, ...rest }) {
  return <Form.Item colon={false} {...rest}>{children}</Form.Item>
}
